const config = {
  app_id: process.env.OED_APP_ID,
  app_key: process.env.OED_APP_KEY,
  proxy_url: process.env.PROXY_URL,
};

export default config;
